export default function LoadingSpinner(): JSX.Element {
  return (
    <div style={{textAlign: 'center'}}>
      <span className="spinner"> </span>
    </div>
  );
}
